import { useMutation } from "@tanstack/react-query";
import clienteAxios from "../../helpers/clienteAxios";

const api = async (x) => {
  const { data } = await clienteAxios.get(
    `sucursalVirtual/tieneLineasParaActivar?id=${x.id}`
  );
  return data;
};

const useLineasPendientes = () => {

  return useMutation(api, {
    onMutate: () => {},
    onSuccess: (response) => {
      return response;
    },
    onError: (error) => {
      return error;
    },
  });
};

export default useLineasPendientes;
